<script setup lang="ts">
import { ref, unref } from 'vue';

import { useExposeCustomModalDialogApi } from '../bootstrap-modal';
import BootstrapModal from '../bootstrap-modal.vue';
import type { CheckboxListModalApi } from './checkbox-list-modal';
import CheckboxListWithSearch from './checkbox-list-with-search.vue';
import type { CheckboxListValue, SelectType } from './radio-list';

const props = defineProps<{
    name?: string;
    title?: string;
    type?: SelectType;
    withTitles?: boolean;
}>();

const modelValue = ref<CheckboxListValue>({});

const [apiExpose, apiRef] = useExposeCustomModalDialogApi<[CheckboxListValue | undefined], CheckboxListValue>({
    onBeforeShow(value) {
        if(value instanceof Map) {
            modelValue.value = new Map(value);
            return;
        }
        modelValue.value = { ...(value ?? {}) };
    },
    onBeforeSubmit() {
        const value = unref(modelValue);
        return value;
    },

});

defineExpose(apiExpose satisfies CheckboxListModalApi);
</script>

<template>
    <BootstrapModal
        ref="apiRef"
        size="modal-fullscreen"
        :title="props.title"
        ok
        cancel
        close
    >
        <CheckboxListWithSearch
            v-model:model-value="modelValue"
            :name="props.name"
            :type="props.type"
            :with-titles="props.withTitles"
        />
    </BootstrapModal>
</template>
